import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Read a cookie value by name (used for the non-httpOnly CSRF cookie set by the API).
function readCookie(name) {
  const match = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/[.$?*|{}()[\]\\/+^]/g, "\\$&") + "=([^;]*)"));
  return match ? decodeURIComponent(match[1]) : null;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true, // always send cookies (httpOnly auth + CSRF)
});

// Attach CSRF header on state-changing requests (double-submit pattern).
// The auth JWT lives in an httpOnly cookie the browser sends automatically.
api.interceptors.request.use((cfg) => {
  const method = (cfg.method || "get").toLowerCase();
  if (["post", "put", "patch", "delete"].includes(method)) {
    const csrf = readCookie("gtec_csrf");
    if (csrf) cfg.headers["X-CSRF-Token"] = csrf;
  }
  return cfg;
});

// Response interceptor: silently swallow 401s so they don't surface as
// "Uncaught (in promise)" noise in the console. Auth-aware components (Protected,
// AuthProvider.fetchMe) already handle the redirect/logout path.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      // Mark as handled so the browser's unhandled-rejection reporter stays quiet.
      err.__silenced = true;
    }
    return Promise.reject(err);
  },
);

export const fileUrl = (path) => `${API}/files/${path}`;
